<template lang="html">
  <div>
    <div >
  <table class="table table-hover table-sm col-md-11" ref="liabilities" :data="liabilities">
  <thead>
    <div class = "row" slot="header">
      <h3 scope="col">
       Liabilities 
      </h3>
    </div>
    <tr>
      <th class="text-center" scope="col">Description</th>
      <th class="text-center" scope="col">Amount</th>
      <th class="text-center" scope="col"></th>
    </tr>
  </thead>
  <tbody>
        <tr v-for="(liability, index) in liabilities" v-bind:key="index" >
          <td class="text-center">
            {{liability.desc}}
          </td>
          <td class="text-center">
            {{liability.amount}}
          </td>
        </tr>
  </tbody>
  </table>
  </div>

 <form v-on:submit.prevent="addliability">
<div class="form-row">
    <div class="form-group col-md-3">
    
      <input type="text" class="form-control" id="description" placeholder="Description" v-model="desc">
    </div>
    <div class="form-group col-md-3">
      <input type="text" class="form-control" id="amount" placeholder="Amount" v-model="amount">
    </div>
    <div class="form-group col-md-3">
      <button type="submit" class="btn btn-primary">Add Liability</button>
    </div>
</div>
</form>
  </div>
</template>

<script>
import db from './firebaseInit'
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');

export default {
  name: 'liabilities',
  data () {
    return {
      liabilities: [],
      desc : null,
      amount : null
    }
  },
  methods: {
addliability(){
  var user = firebase.auth().currentUser;
  var userId
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('liabilities').add({
 
    desc: this.desc,
    amount: parseFloat(this.amount)
  }).then(ref => {
    const data = {
    'id' : ref.id,
    desc: this.desc,
    amount: '$' + parseFloat(this.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  }
  this.liabilities.push(data)
  this.desc = ''
  this.amount = ''
})
}
  },
  created (){  
    var userId
  var user = firebase.auth().currentUser;
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('liabilities').get().then
  (querySnapshot => {
    querySnapshot.forEach(doc => {
      //console.log(doc.data());
      const data = {
        'id' : doc.id,
        'desc' : doc.data().desc,
        'amount' : '$' + (doc.data().amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      }
      this.liabilities.push(data)
      //console.log(data)
    })
  }
  )
  }
}
</script>